import http from 'config/http';

import { CameraCCTVModel } from 'api/models';
import { getApiUrl } from 'config/api-url';
import { PtzControlsPayload } from 'api/types';

/* -------------------------------------------------------------------------------------------------
 * Get all
 * -----------------------------------------------------------------------------------------------*/

export const getAllCctvCameras = async (projectId: string) => {
    const { data } = await http.get(`${getApiUrl()}/projects/${projectId}/camera-cctvs`);

    return CameraCCTVModel.fromObjectList(data);
};

/* -------------------------------------------------------------------------------------------------
 * Get by Id
 * -----------------------------------------------------------------------------------------------*/

export const getCctvCameraById = async (projectId: string, cameraId: string) => {
    const { data } = await http.get(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}`);

    return CameraCCTVModel.fromObject(data);
};

/* -------------------------------------------------------------------------------------------------
 * Update
 * -----------------------------------------------------------------------------------------------*/

export const updateCctvCamera = async (projectId: string, cameraId: string, payload: Partial<CameraCCTVModel>) => {
    await http.put(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}`, payload);
};

export const resetPtzCamera = async (projectId: string, cameraId: string, payload: { channelNumber: string }) => {
    await http.post(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz/presets/go-to-home`, payload);
};

/* -------------------------------------------------------------------------------------------------
 * PTZ CAMERA
 * -----------------------------------------------------------------------------------------------*/
export const updatePtzCameraControlPan = async (
    projectId: string,
    cameraId: string,
    payload: Pick<PtzControlsPayload, 'pan'> & { channelNumber: string }
) => {
    await http.post(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz/pan`, payload);
};

export const updatePtzCameraControlTilt = async (
    projectId: string,
    cameraId: string,
    payload: Pick<PtzControlsPayload, 'tilt'> & { channelNumber: string }
) => {
    await http.post(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz/tilt`, payload);
};

export const updatePtzCameraControlZoom = async (
    projectId: string,
    cameraId: string,
    payload: Pick<PtzControlsPayload, 'zoom'> & { channelNumber: string }
) => {
    await http.post(`${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/ptz/zoom`, payload);
};

/* -------------------------------------------------------------------------------------------------
 * Stream Token
 * -----------------------------------------------------------------------------------------------*/
export const getStreamToken = async (projectId: string, cameraId: string) => {
    const { data } = await http.post<{ token: string }>(
        `${getApiUrl()}/projects/${projectId}/camera-cctvs/${cameraId}/stream-tokens`,
        {}
    );
    return data.token;
};
